import { h, Component } from 'preact';

import './index.less';
import EventBus from '../../lib/EventBus';
import Search from '../../molecules/Icon/Search';
import { cdnHost } from '../../../config';
import { addClass, removeClass } from '../../lib/Dom';

class ListSearchPicker extends Component {
  state = {
    selectedValue: '',
    searchTerm: '',
    isVisible: false,
    placeHolderText: '',
    listEndComponent: null
  };

  componentDidMount () {
    EventBus.addListener(EventBus.TYPE.SHOW_LIST_SEARCH_PICKER, this.onShow);
    EventBus.addListener(EventBus.TYPE.HIDE_LIST_SEARCH_PICKER, this.onHide);
    EventBus.addListener(EventBus.TYPE.ROUTE_CHANGE, this.onRouteChange);
  }

  componentDidUpdate (previousProps, previousState) {
    const { isVisible, selectedValue } = this.state;

    if (selectedValue && this.listRef) {
      const listItemElement = document.querySelector(
        `.list-search-picker .list-item-${selectedValue.replace(/ /g, '')}`
      );

      if (listItemElement) {
        this.listRef.scrollTo(0, listItemElement.offsetTop - this.listRef.offsetTop);
      }
    }

    if (isVisible && !previousState.isVisible && this.searchInput) {
      this.searchInput.focus();
    }
  }

  componentWillUnmount () {
    EventBus.removeListener(EventBus.TYPE.SHOW_LIST_SEARCH_PICKER, this.onShow);
    EventBus.removeListener(EventBus.TYPE.HIDE_LIST_SEARCH_PICKER, this.onHide);
    EventBus.removeListener(EventBus.TYPE.ROUTE_CHANGE, this.onRouteChange);
  }

  onShow = ({ selectedValue, onSelect, list, placeHolderText, listEndComponent = null } = {}) => {
    this.onSelect = onSelect;
    this.list = list;
    this.setState({
      selectedValue: selectedValue || '',
      isVisible: true,
      placeHolderText,
      listEndComponent
    });
    addClass(document.querySelector('body'), 'block-scroll');
  };

  onHide = () => {
    removeClass(document.querySelector('body'), 'block-scroll');
    this.setState({
      isVisible: false,
      selectedValue: '',
      searchTerm: '',
      placeHolderText: '',
      listEndComponent: null
    });
  };

  onRouteChange = () => {
    EventBus.notify(EventBus.TYPE.HIDE_LIST_SEARCH_PICKER);
  };

  onSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  onListItemSelect = (event, listItem) => {
    EventBus.notify(EventBus.TYPE.HIDE_LIST_SEARCH_PICKER);
    this.onSelect(event, listItem);
  };

  onClosePress = () => {
    EventBus.notify(EventBus.TYPE.HIDE_LIST_SEARCH_PICKER);
  };

  getFilteredList = () => {
    const { searchTerm } = this.state;

    if (!searchTerm) {
      return this.list;
    }

    return this.list.filter(
      (listItem) => listItem.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
    );
  };

  render () {
    const { searchTerm, selectedValue, isVisible, placeHolderText, listEndComponent } = this.state;

    if (!isVisible) {
      return <div />;
    }

    const list = this.getFilteredList();

    return (
      <div className="list-search-picker-container">
        <div className="list-search-picker">
          <div className="search-bar">
            <div className="search-icon">
              <Search size={20} color="#aaa" />
            </div>

            <div className="input-container">
              <input
                ref={(element) => (this.searchInput = element)}
                type="text"
                placeholder={placeHolderText}
                autoComplete="new-password"
                value={searchTerm}
                onInput={this.onSearchChange}
              />
            </div>

            <div className="close-icon" onClick={this.onClosePress}>
              <img alt src={`${cdnHost}assets/close-black.svg`} />
            </div>
          </div>

          <div ref={(element) => (this.listRef = element)} className="list">
            {list.map((listItem) => (
              <div
                className={`list-item list-item-${listItem.replace(/ /g, '')} ${
                  selectedValue === listItem ? 'selected' : ''
                }`}
                onClick={(event) => this.onListItemSelect(event, listItem)}
              >
                <div className="name">{listItem}</div>
              </div>
            ))}
            {listEndComponent}
          </div>
        </div>
      </div>
    );
  }
}

export default ListSearchPicker;
